/* This is list of order status in CMP, Don't change the order of array, add new once at last */
import { FAILED, RUNNING, SUCCESS } from 'utils/ValidationStatus';

export const orderStatus = [
    { name: 'Pending Approval', statusCode: 'PendingApproval' },
    { name: 'Provisioning', statusCode: 'Provisioning' },
    { name: 'Cancelled', statusCode: 'Cancelled' },
    { name: 'Rejected', statusCode: 'Rejected' },
    { name: 'Completed', statusCode: 'Completed' },
    { name: 'User Action Required', statusCode: 'ReturnToUser' },
    { name: 'Provisioning Completed', statusCode: 'ProvisioningComplete' },
    { name: 'in-progress', statusCode: 'INPROGRESS' },
    { name: `Validation ${RUNNING}`, statusCode: 'ValidationRunning' },
    { name: `Validation ${SUCCESS}`, statusCode: 'ValidationSuccess' },
    { name: `Validation ${FAILED}`, statusCode: 'ValidationFailed' },
    { name: 'Failed', statusCode: 'Failed' },
];

export const ORDER_STATUS_MAP = {
    PENDING_STATUS: orderStatus[0]?.name,
    PROVISIONING_STATUS: orderStatus[1]?.name,
    CANCELLED_STATUS: orderStatus[2]?.name,
    REJECTED_STATUS: orderStatus[3]?.name,
    COMPLETED_STATUS: orderStatus[4]?.name,
    USER_ACTION_REQUIRED_STATUS: orderStatus[5]?.name,
    PROVISIONING_COMPLETED_STATUS: orderStatus[6]?.name,
    IN_PROGRESS_STATUS: orderStatus[7]?.name,
    VALIDATION_RUNNING_STATUS: orderStatus[8]?.name,
    VALIDATION_SUCCESS_STATUS: orderStatus[9]?.name,
    VALIDATION_FAILED_STATUS: orderStatus[10]?.name,
    FAILED_STATUS: orderStatus[11]?.name,
    APPROVED: 'Approved',
};

export default orderStatus;
